import { motion } from 'framer-motion'

/**
 * Fade In Animation
 * @param delay - Delay in seconds
 * @param duration - Animation duration in seconds
 */
export const fadeIn = (delay = 0, duration = 0.5) => ({
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { delay, duration }
})

/**
 * Slide In From Left
 */
export const slideInLeft = (delay = 0, duration = 0.5) => ({
    initial: { x: -50, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -50, opacity: 0 },
    transition: { delay, duration, ease: 'easeOut' }
})

/**
 * Slide In From Right
 */
export const slideInRight = (delay = 0, duration = 0.5) => ({
    initial: { x: 50, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 50, opacity: 0 },
    transition: { delay, duration, ease: 'easeOut' }
})

/**
 * Slide In From Top
 */
export const slideInTop = (delay = 0, duration = 0.5) => ({
    initial: { y: -50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -50, opacity: 0 },
    transition: { delay, duration, ease: 'easeOut' }
})

/**
 * Slide In From Bottom
 */
export const slideInBottom = (delay = 0, duration = 0.5) => ({
    initial: { y: 50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 50, opacity: 0 },
    transition: { delay, duration, ease: 'easeOut' }
})

/**
 * Scale Up Animation
 */
export const scaleUp = (delay = 0, duration = 0.5) => ({
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.8, opacity: 0 },
    transition: { delay, duration, ease: 'easeOut' }
})

/**
 * Bounce In Animation
 */
export const bounceIn = (delay = 0) => ({
    initial: { scale: 0, opacity: 0 },
    animate: {
        scale: 1,
        opacity: 1,
        transition: {
            delay,
            type: 'spring',
            stiffness: 260,
            damping: 20
        }
    }
})

/**
 * Stagger Children Animation
 * @param staggerChildren - Delay between children animations
 */
export const staggerContainer = (staggerChildren = 0.1) => ({
    animate: {
        transition: {
            staggerChildren
        }
    }
})

/**
 * Hover Scale Animation (for buttons, cards)
 */
export const hoverScale = {
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 }
}

/**
 * Hover Lift Animation (for cards)
 */
export const hoverLift = {
    whileHover: {
        y: -5,
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        transition: { duration: 0.2 }
    }
}

/**
 * Page Transition Animation
 */
export const pageTransition = {
    initial: { opacity: 0, x: -20 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 20 },
    transition: { duration: 0.3 }
}

/**
 * Modal Animation
 */
export const modalAnimation = {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
    transition: { duration: 0.2, ease: 'easeOut' }
}

/**
 * Backdrop Animation
 */
export const backdropAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
}
